import { useEffect } from "react";
import { useForm } from "react-hook-form";

import useShop from "../../hooks/useShop.hook";
import useShopList from "../../hooks/useShopList.hook";

export default function ShopList() {
  const { reset } = useForm();
  const { data: shops } = useShopList();
  const { selectedShop, selectShop } = useShop();

  useEffect(() => {
    reset({
      selectedShopId: selectedShop ? selectedShop.id : null,
    });
    // eslint-disable-next-line
  }, []);

  function changeShop(shopId: string) {
    const selectedShop = shops!.find((s) => s.id === shopId);
    selectShop(selectedShop!.id);
  }

  const selectCss =
    "px-3 py-2 " + //
    "rounded  " +
    "text-black dark:text-her-gray dark:bg-her-backblue ";

  if (!shops) return null;

  if (shops.length === 1) return <span>{shops[0].name.en}</span>;

  return (
    <select id="choose-shop" className={selectCss} onChange={(e) => changeShop(e.target.value)} value={selectedShop?.id}>
      {shops?.map((s) => (
        <option key={s.id} value={s.id}>
          {s.name.en}
        </option>
      ))}
    </select>
  );
}
